<template>
  <v-chip
    v-if="variant?.person?.name"
    :href="
      !registerAsLink && variant?.person?.page_slug
        ? `/trainers/${variant.person.page_slug}`
        : undefined
    "
    class="ml-1 my-1"
    color="light-blue-darken-2"
    size="small"
    variant="elevated"
  >
    {{ variant.person.name }}</v-chip
  >
  <v-chip
    v-if="
      !hideInfoButton &&
      variant?.product?.code &&
      (variant?.product?.occasion_type?.code === 'C' ||
        variant?.product?.occasion_type?.code === 'W')
    "
    :href="infoHref"
    class="ml-1 my-1"
    color="light-blue-darken-2"
    size="small"
    variant="elevated"
  >
    {{ variant.product.code }}</v-chip
  >
  <v-chip v-if="variant?.delivery_method?.name" class="ml-1 my-1" size="small">
    {{ variant.delivery_method.name }}</v-chip
  >
  <v-chip
    v-if="variant?.product?.occasion_type?.name"
    class="ml-1 my-1"
    size="small"
  >
    {{ variant.product.occasion_type.name }}</v-chip
  >
  <v-chip
    v-if="variant?.product?.methodology?.name"
    class="ml-1 my-1"
    size="small"
  >
    {{ variant.product.methodology.name }}</v-chip
  >
</template>

<script setup lang="ts">
import type { VariantFeedItem } from '#root/types/variants'

withDefaults(
  defineProps<{
    hideInfoButton?: boolean
    infoHref?: string
    registerAsLink?: boolean
    variant?: VariantFeedItem | null
  }>(),
  {
    hideInfoButton: false,
    infoHref: undefined,
    registerAsLink: false,
    variant: null
  }
)
</script>
